import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    button: {
      margin: 0,

      '&:first-child > span': {
        color: '#727970',
        position: 'relative',

        '& > :last-child, &:hover > :first-child': {
          display: 'none',
        },

        '&:hover > :last-child': {
          display: 'inline',
        },

        '&::before': {
          content: '""',
          position: 'absolute',
          top: 2,
          left: 2,
          right: 2,
          bottom: 2,
          backgroundColor: palette.background.paper,
          borderRadius: '50%',
          zIndex: -1,
        },
      },
    },

    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem',
      paddingLeft: '1.6rem',

      backgroundColor: '#F0F1EB',

      '& > h3': {
        fontSize: '2.2rem',
      },
    },

    content: {
      padding: '1.6rem',

      '& > ul': {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        marginRight: '8rem',

        '& > li': {
          display: 'flex',
          alignItems: 'center',
          gap: '2rem',
          marginBottom: '1rem',
          fontSize: '1.2rem',

          '& > div': {
            width: 16,
            height: 16,
            borderRadius: 5,
            borderWidth: 1,
            borderStyle: 'solid',
          },
        },
      },
    },
  }),
)
